import { ActionTypes } from "../../../reducer/propertyReducer";
import Select from "../../../../shared/select/Select";
import ButtonGroup from "../../../../shared/button-group/ButtonGroup";
import { sortByOptions, specialtyFeatureOptions, zoningOptions } from "../../utils/dropdown-options";
import { iSitesForm } from "./interfaces";
import { ForwardRefRenderFunction, forwardRef } from "react";
import Radius, { RadiusHandle } from "../radius/Radius";

const SitesForm: ForwardRefRenderFunction<RadiusHandle, iSitesForm> = ({
  view,
  radiusSketchLayer,
  state,
  dispatch,
  flexDirection,
  inputStyle,
  stateOptions,
  regionOptions,
  sCityOpts,
  sCountyOpts,
  filterByMapExtentHandler,
  filterByMapExtentValue,
  setRadiusFilterGeometry
}, ref) => {
  return (
    <>
      <div className="flex-form">
        <div className={`${flexDirection} gap-12`}>
          <div className="input-container" style={inputStyle}>
            <label htmlFor="sKeywordSearch">Keyword Search</label>
            <input
              placeholder='Search..'
              type="text"
              name="sKeywordSearch"
              value={state.sKeywordSearch}
              onChange={(evt) => dispatch({ type: ActionTypes.SetSKeywordSearch, payload: evt.target.value })}
            />
          </div>
          <div className="input-container" style={inputStyle}>
            <label htmlFor="sAvailableSqFt">Available Acres</label>
            <div id="acres-input" className="flex-row align-items-center">
              <input
                type="number"
                name="sAvailableAcresMin"
                placeholder='0'
                value={state.sAvailableAcresMin}
                min={0}
                onChange={(evt) => dispatch({ type: ActionTypes.SetSAvailableAcresMin, payload: evt })}
              />
              <span>-</span>
              <input
                type="number"
                name="sAvailableAcresMax"
                placeholder="Enter Max"
                value={state.sAvailableAcresMax}
                onChange={(evt) => dispatch({ type: ActionTypes.SetSAvailableAcresMax, payload: evt })}
              />

            </div>
          </div>
        </div>
        <div className={`${flexDirection} gap-12`}>
          <div className="input-container" style={inputStyle}>
            <Select
              label={'Specialty Features'}
              labelPosition='top'
              multiSelect={true}
              selectedItems={Array.from(state.sSpecialtyFeatures)}
              onClear={() => dispatch({ type: ActionTypes.SetSSpecialtyFeatures, payload: new Set() })}>
              <div >
                {specialtyFeatureOptions?.map((option: any) =>
                  <div key={option} className="filter-option">
                    <input
                      type="checkbox"
                      id={`sSpecialtyFeatures-${option}`}
                      value={option}
                      checked={state.sSpecialtyFeatures.has(option)}
                      onChange={(evt) => dispatch({ type: ActionTypes.SetSSpecialtyFeatures, payload: evt })} />
                    <label htmlFor={`sSpecialtyFeatures-${option}`}>{option}</label>
                  </div>
                )}
              </div>
            </Select>
          </div>

          <div className="input-container" style={inputStyle}>
            <ButtonGroup
              groupLabel='Rail Served'
              buttons={['All', 'Yes', 'No', 'Maybe']}
              onChange={(evt) => dispatch({ type: ActionTypes.SetSRailServed, payload: evt.currentTarget.name })}
              value={state.sRailServed}
            />
          </div>
        </div>

        <div className={`${flexDirection} gap-12`}>
          <div className="input-container" style={inputStyle}>
            <Select
              label={'Zoning Descriptions'}
              labelPosition='top'
              multiSelect={true}
              selectedItems={Array.from(state.sZoning)}
              onClear={() => dispatch({ type: ActionTypes.SetSZoning, payload: new Set() })}>
              <div >
                {zoningOptions?.map((option: any) =>
                  <div key={option} >
                    <input
                      type="checkbox"
                      id={`sZoning-${option}`}
                      value={option}
                      checked={state.sZoning.has(option)}
                      onChange={(evt) => dispatch({ type: ActionTypes.SetSZoning, payload: evt })} />
                    <label htmlFor={`sZoning-${option}`}>{option}</label>
                  </div>
                )}
              </div>
            </Select>
          </div>
          <div className="input-container" style={inputStyle}>
            <ButtonGroup
              groupLabel='Site Certified'
              buttons={['All', 'Yes', 'No']}
              onChange={(evt) => dispatch({ type: ActionTypes.SetSSiteCertified, payload: evt.currentTarget.name })}
              value={state.sSiteCertified}
            // disabled={state.properties.findIndex(e => e.attributes.site_certified) === -1}
            // disabled={true}
            />
          </div>
        </div>

        {/* <div className={`${flexDirection} gap-12`}>
								  <div className="input-container" style={inputStyle}>
									<Select
									  label={'Review Status'}
									  labelPosition='top'
									  multiSelect={true}
									  selectedItems={Array.from(state.sReviewStatus)}
									  onClear={() => dispatch({ type: ActionTypes.SetSReviewStatus, payload: new Set() })}>
									  <div >
										{reviewStatusOptions?.map((option: any) =>
										  <div key={option} className="filter-option">
											<input
											  type="checkbox"
											  id={`sReviewStatus-${option}`}
											  value={option}
											  checked={state.sReviewStatus.has(option)}
											  onChange={(evt) => dispatch({ type: ActionTypes.SetSReviewStatus, payload: evt })} />
											<label htmlFor={`sReviewStatus-${option}`}>{option}</label>
										  </div>
										)}
									  </div>
									</Select>
								  </div>
				  
								</div> */}

        <div className={`${flexDirection} gap-12`}>
          <div className="input-container" style={inputStyle}>
            <Select
              label={'State(s)'}
              labelPosition='top'
              multiSelect={true}
              disabled={state.sRegions.size > 0}
              disabledText={'Clear Region to select a State'}
              selectedItems={Array.from(state.sStates)}
              onClear={() => dispatch({ type: ActionTypes.SetSStates, payload: new Set() })}>
              <div className='state-select'>
                {stateOptions.map((option: any) =>
                  <div key={option.label} className="state-option">
                    <input
                      type="checkbox"
                      id={`sStates-${option.value}`}
                      value={option.value}
                      checked={state.sStates.has(option.value)}
                      onChange={(evt) => dispatch({ type: ActionTypes.SetSStates, payload: evt })} />
                    <label htmlFor={`sStates-${option.value}`}>{option.label}</label>
                  </div>
                )}
              </div>
            </Select>
          </div>

          <div className="input-container" style={inputStyle}>
            <Select
              label={'Region'}
              labelPosition='top'
              multiSelect={true}
              disabled={state.sStates.size > 0}
              disabledText={'Clear State to select a Region'}
              selectedItems={Array.from(state.sRegions)}
              onClear={() => dispatch({ type: ActionTypes.SetSRegions, payload: new Set() })}>
              <div>
                {Array.from(regionOptions).map((option: any) =>
                  <div key={option} className='filter-option'>
                    <input
                      type="checkbox"
                      id={`sRegions-${option}`}
                      value={option}
                      checked={state.sRegions.has(option)}
                      onChange={(evt) => dispatch({ type: ActionTypes.SetSRegions, payload: evt })} />
                    <label htmlFor={`sRegions-${option}`}>{option}</label>
                  </div>
                )}
              </div>
            </Select>
          </div>
        </div>

        <div className={`${flexDirection} gap-12`}>
          <div className="input-container" style={inputStyle}>
            <Select
              label={'City'}
              labelPosition='top'
              multiSelect={true}
              disabled={(state.sStates.size === 0 && state.sRegions.size === 0) || sCityOpts.length === 0}
              disabledText={(state.sStates.size === 0 && state.sRegions.size === 0) ? 'Select a state or region' : 'No cities found'}
              selectedItems={Array.from(state.sCities)}
              onClear={() => dispatch({ type: ActionTypes.SetSCities, payload: new Set() })}>
              <div>
                {sCityOpts.map((option: any) =>
                  <div key={option} className="filter-option">
                    <input
                      type="checkbox"
                      id={`sCities-${option}`}
                      value={option}
                      checked={state.sCities.has(option)}
                      onChange={(evt) => dispatch({ type: ActionTypes.SetSCities, payload: evt })} />
                    <label htmlFor={`sCities-${option}`}>{option}</label>
                  </div>
                )}
              </div>
            </Select>
          </div>

          <div className="input-container" style={inputStyle}>
            <Select
              label={'County'}
              labelPosition='top'
              multiSelect={true}
              disabled={(state.sStates.size === 0 && state.sRegions.size === 0) || sCountyOpts.length === 0}
              disabledText={(state.sStates.size === 0 && state.sRegions.size === 0) ? 'Select a state or region' : 'No counties found'}
              selectedItems={Array.from(state.sCounties)}
              onClear={() => dispatch({ type: ActionTypes.SetSCounties, payload: new Set() })}>
              <div>
                {sCountyOpts.map((option: any) =>
                  <div key={option} className="filter-option">
                    <input
                      type="checkbox"
                      id={`sCounties-${option}`}
                      value={option}
                      checked={state.sCounties.has(option)}
                      onChange={(evt) => dispatch({ type: ActionTypes.SetSCounties, payload: evt })} />
                    <label htmlFor={`sCounties-${option}`}>{option}</label>
                  </div>
                )}
              </div>
            </Select>
          </div>
        </div>

        <div className={`${flexDirection} gap-12`}>
          <div className="input-container" style={inputStyle}>
            <Select
              label={'Sort List Results By'}
              labelPosition='top'
              multiSelect={false}
              selectedItems={[state.sSortBy]}
            >
              {sortByOptions.map((option) =>
                <div onClick={() => dispatch({ type: ActionTypes.SetSSortBy, payload: option })} className="select-option" key={option}>{option}</div>
              )}
            </Select>
          </div>

          <div className="input-container" style={inputStyle}></div>
        </div>
        <div className={`${flexDirection} gap-12`}>
          <div className="input-container" style={inputStyle}>
            <ButtonGroup
              groupLabel='Filter By Map Extent'
              buttons={['Yes', 'No']}
              onChange={(evt) => filterByMapExtentHandler(evt)}
              value={filterByMapExtentValue === true ? 'Yes' : 'No'}
            />
          </div>
          <div className="input-container" style={inputStyle}>
            <div className="input-container" style={inputStyle}>
              <ButtonGroup
                groupLabel='For Sale or Lease'
                buttons={['All', 'Sale', 'Lease']}
                onChange={(evt) => dispatch({ type: ActionTypes.SetSSaleOrLease, payload: evt.currentTarget.name })}
                value={state.sSaleOrLease}
              />
            </div>
          </div>
        </div>

        <div className='flex-row'>
          <div className="input-container" style={inputStyle}>
            <Radius
              ref={ref}
              mapView={view}
              sketchLayer={radiusSketchLayer}
              centerPoint={state.radiusCenterPoint}
              setRadiusGeometry={setRadiusFilterGeometry}
            />
          </div>
        </div>
      </div>
      <div className="filler"></div>
    </>
  );
}

export default forwardRef(SitesForm);